import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { PageMetaResolver, PaginationModel, Product, ProductScope, ProductService } from "@spartacus/core";
import { Subscription } from "rxjs";
import { distinctUntilChanged, filter, first, switchMap, take, tap } from "rxjs/operators";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { CommonModule } from '@angular/common';
import { SpinnerModule, PaginationModule } from '@spartacus/storefront';
import { BundleSlideModule } from 'src/app/generac/shared/components/bundle-slide/bundle-slide.module';
import { GenBundle } from 'src/app/generac/models/bundle.model';
import { GenLoadingEnum } from 'src/app/generac/enums/loading.enum';
import { GenBundleService } from 'src/app/generac/services/bundle.service';
import { GenCustomerService } from 'src/app/generac/services/customer.service';
import { GenProductBundleListResolver } from 'src/app/generac/resolvers/product-bundle-list.resolver';

@Component({
  selector: 'gen-bundle-list',
  templateUrl: './product-bundle-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    SpinnerModule,
    BundleSlideModule,
    RouterModule,
    PaginationModule,
  ],
  providers: [
    {
      provide: PageMetaResolver,
      useExisting: GenProductBundleListResolver,
      multi: true,
    },
  ]
})
export class GenProductBundleListComponent {
  pagination: PaginationModel;
  bundles: GenBundle[] = [];
  loading: GenLoadingEnum = GenLoadingEnum.Idle;
  GenLoadingEnum = GenLoadingEnum;
  product: Product;
  private unit: string;
  private subscription = new Subscription();

  constructor(
    private bundleService: GenBundleService,
    private cdr: ChangeDetectorRef,
    private customerService: GenCustomerService,
    private productService: ProductService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.product = {
      code: this.route.snapshot.url[1].path
    };
    this.getBundles();
    this.subscribeToLoadingState();
    this.subscribeToProduct();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  trackByBundle(_: number, bundle: GenBundle) {
    return bundle.id;
  }

  addBundleToTheCart(bundle: GenBundle) {
    this.bundleService.addToCart(bundle.id, bundle.product.code)
      .pipe(filter(response => !!response?.error?.message?.length))
      .subscribe(response => {
        bundle.errorMessages = response?.error?.message;
      });
  }

  onPaginate(paginate: number): void {
    this.loading = GenLoadingEnum.Loading;
    this.bundleService.getBundlesList(this.unit, this.product.code, paginate).pipe(
      first()
    ).subscribe(([pagination, bundles]) => {
      this.pagination = pagination;
      this.bundles = bundles;
      this.cdr.detectChanges();
    });
  }

  private getBundles() {
    this.subscription.add(
      this.customerService.getCurrentB2bUnit().pipe(
        filter(unit => !!unit),
        distinctUntilChanged(),
        tap(unit => this.unit = unit),
        switchMap((unit) => this.bundleService.getBundlesList(unit, this.product.code)),
      ).subscribe(([pagination, bundles]) => {
        this.pagination = pagination;
        this.bundles = bundles;
        this.cdr.markForCheck();
      }),
    )
  }

  private subscribeToProduct() {
    this.subscription.add(
      this.productService.get(this.product.code, [
        ProductScope.DETAILS,
        ProductScope.PRICE,
      ]).pipe(
        filter((product) => !!product),
        take(1)
      ).subscribe(product => this.product = product)
    )
  }

  private subscribeToLoadingState() {
    this.subscription.add(
      this.bundleService.loading$
        .subscribe(loading => {
          this.loading = loading;
          this.cdr.markForCheck();
        })
    );
  }

}
